import React from 'react';
import PropTypes from 'prop-types';
import { propTypes as picturePropTypes } from '../../../01_atoms/DefaultPicture';
import BBImageWithCaption from '../BBImageWithCaption';
import FormattedText from '../../../01_atoms/FormattedText';
import {
  behaviorSettingsProps,
  generateClassNameByBehaviorSettings,
} from '../../../../utils/behaviorSettings';

import styles from './index.module.scss';

const BBTextWithSideImage = ({
  image,
  imageCaption = '',
  className = 'image-right',
  heading = '',
  text,
  behaviorSettings = null,
  uuid = null,
}) => (
  <div
    className={`bb ${
      styles['bb-text-with-side-image']
    } ${className} ${generateClassNameByBehaviorSettings(behaviorSettings)}`}
    id={uuid}
  >
    <div className="container">
      {heading && (
        <div className="bb-text-with-side-image__heading">
          <h3>{heading}</h3>
        </div>
      )}
      <div className="bb-text-with-side-image__content">
        <FormattedText className="bb-text-with-side-image__text" text={text} />
        <BBImageWithCaption image={image} imageCaption={imageCaption} className="side-image" />
      </div>
    </div>
  </div>
);

BBTextWithSideImage.propTypes = {
  heading: PropTypes.string,
  text: PropTypes.string.isRequired,
  image: PropTypes.shape(picturePropTypes).isRequired,
  imageCaption: PropTypes.string,
  /**
   * Use `image-left` for left image positioning.
   */
  className: PropTypes.string,
  behaviorSettings: behaviorSettingsProps,
  uuid: PropTypes.string,
};

export default BBTextWithSideImage;
